<template>
  <ok-text-input
    :value="value"
    :label="$t('general.please-select')"
    :is-required="isRequired"
    hide-label
    :hide-error="hideErrors"
  >
    <v-select
      :value="value"
      :placeholder="$t('general.please-select')"
      :options="options"
      :reduce="reduce || (u => u.id)"
      label="name"
      :loading="loading"
      :filterable="false"
      :disabled="disabled"
      dir="rtl"
      @search="search"
      @input="$emit('input', $event)"
    />
  </ok-text-input>
</template>

<script>
import VSelect from 'vue-select'
import debounce from 'lodash/debounce'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import PageApi from '@/api/page'
import axios from 'axios'

export default {
  name: 'PagesAutoComplete',
  components: { OkTextInput, VSelect },
  props: {
    value: {
      required: false,
    },
    reduce: {
      type: Function,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyAdmin: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    hideErrors: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      searchQuery: '',
    }
  },
  watch: {
    value() {
      this.fetchBasedId()
    },
  },
  mounted() {
    this.fetchBasedId()
  },
  methods: {
    fetchBasedId() {
      if (this.value && !this.options.find(u => u.id === this.value)) {
        this.searchQuery = `${this.value}`
        this.debouncedFetchOptions()
      }
    },
    debouncedFetchOptions: debounce(function () {
      this.fetchOptions()
    }, 300),
    search(search) {
      this.searchQuery = search
      if (search.length) {
        this.debouncedFetchOptions()
      }
    },
    fetchOptions() {
      if (!this.searchQuery?.length) {
        return
      }
      this.loading = true
      PageApi.suggestions(this.searchQuery)
        .then(users => { this.options = users?.slice(0, 50) ?? [] })
        .catch(err => {
          if (axios.isCancel(err)) {
            return
          }
          this.$notifyError(err)
        })
        .finally(() => { this.loading = false })
    },
    deselectAll() {
      this.$emit('input', '')
    },
  },
}
</script>
